import React, { useState } from "react";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";
import { Avatar, Button, Container, CssBaseline, InputAdornment, IconButton, Link, TextField, Typography } from "@material-ui/core";
import { LockOutlined, Visibility, VisibilityOff } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: { width: "100%", marginTop: theme.spacing(2) },
  submit: { margin: theme.spacing(3, 0, 2) },
}));

const ResetPassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    if (password.length < 8) return toast.error("La contraseña debe tener al menos 8 caracteres.");
    if (password !== confirmation) return toast.error("Las contraseñas no coinciden.");
    if (!token) return toast.error("El enlace de recuperación no es válido.");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña actualizada. Ya podés iniciar sesión.");
      history.replace("/login");
    } catch (error) {
      toastError(error);
    } finally {
      setSubmitting(false);
    }
  };

  const passwordAdornment = (
    <InputAdornment position="end">
      <IconButton aria-label="mostrar contraseña" onClick={() => setShowPassword(value => !value)}>
        {showPassword ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  );

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}><LockOutlined /></Avatar>
        <Typography component="h1" variant="h5">Nueva contraseña</Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Nueva contraseña"
            type={showPassword ? "text" : "password"}
            autoComplete="new-password"
            value={password}
            onChange={event => setPassword(event.target.value)}
            InputProps={{ endAdornment: passwordAdornment }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Repetir contraseña"
            type={showPassword ? "text" : "password"}
            autoComplete="new-password"
            value={confirmation}
            onChange={event => setConfirmation(event.target.value)}
          />
          <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit} disabled={submitting || !token}>
            {submitting ? "Guardando…" : "Restablecer contraseña"}
          </Button>
          {!token && <Typography color="error">Este enlace no contiene un token válido.</Typography>}
          <Link component={RouterLink} to="/login" variant="body2">Volver a iniciar sesión</Link>
        </form>
      </div>
    </Container>
  );
};

export default ResetPassword;
